import React from "react";
import { HiOutlinePhoto } from "react-icons/hi2";
import { useLanguage } from "../../../contexts/LanguageContext";

export function RecipeSelector({ recipes, loading, selectedRecipe, onSelect }) {
  const { t } = useLanguage();

  return (
    <div className="bg-white dark:bg-slate-800/60 backdrop-blur rounded-xl border border-ink-900/10 dark:border-white/10 p-5">
      <label className="block text-sm font-medium text-ink-700 dark:text-white/90 mb-2">
        {t("selectRecipe")}
      </label>
      {loading ? (
        <p className="text-ink-400 dark:text-white/60 text-sm">{t("loadingRecipes")}</p>
      ) : recipes.length === 0 ? (
        <p className="text-ink-400 dark:text-white/60 text-sm">{t("noRecipesForPoster")}</p>
      ) : (
        <div className="space-y-1.5 max-h-44 overflow-y-auto">
          {recipes.map((rec) => (
            <button
              key={rec.id}
              type="button"
              onClick={() => onSelect(rec)}
              className={`w-full flex items-center gap-3 p-2.5 rounded-lg text-left transition-all ${
                selectedRecipe?.id === rec.id
                  ? "bg-orange-500 text-white dark:bg-orange-500/40 dark:text-white"
                  : "bg-ink-100 text-ink-700 hover:bg-ink-200 dark:bg-white/5 dark:text-white/80 dark:hover:bg-white/10"
              }`}
            >
              {rec.image_url || rec.image ? (
                <img
                  src={rec.image_url || rec.image}
                  alt=""
                  className="w-10 h-10 rounded-md object-cover shrink-0"
                />
              ) : (
                <div className="w-10 h-10 rounded-md bg-ink-100 dark:bg-white/10 flex items-center justify-center shrink-0">
                  <HiOutlinePhoto className="w-5 h-5 text-ink-400 dark:text-white/50" />
                </div>
              )}
              <span className="text-sm font-medium truncate">
                {rec.title || "Sans titre"}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
